module.exports = __webpack_public_path__ + "img/labmemtest_btn_download_sc.f2dc00e8.png";